module.exports = __webpack_public_path__ + "img/banner_police.935e96f0.jpg";